import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import DashboardHeader from "../../Pages/DashboardHeader/DboardHeader";
import Sidebarcomp from "../../Pages/Sidebar/Sidebar";
import "./HomeOwnerAdmin.css";
import { HomeOwner } from "../../Utils/Constant";

function HomeOwnerAdmin() {
  const navigate = useNavigate();

  useEffect(() => {
    // Retrieve the access token and user role from localStorage
    const accessToken = localStorage.getItem("access_token");
    const userType = localStorage.getItem("user_type");

    // Check if the user is authenticated and is a super-admin
    if (!accessToken || !userType || userType !== HomeOwner) {
      // If not authenticated or not a super-admin, redirect to login page
      navigate("/login");
    }
  }, [navigate]);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="layout d-flex">
      <Sidebarcomp isCollapsed={isCollapsed} onToggle={toggleSidebar} />
      <div
        className={`main-components d-flex flex-column ${isCollapsed ? "full-width" : ""
          }`}
      >
        <DashboardHeader />

        <Outlet />
      </div>
    </div>
  );
}

export default HomeOwnerAdmin;
